import { apiGET } from './api';

export const getUnits = () => apiGET('/units');
